// core-js/stable and regenerator-runtime/runtime need to be the first lines in
// the entry file!
// eslint-disable-next-line sort-imports-es6-autofix/sort-imports-es6
import 'core-js/stable';
// eslint-disable-next-line sort-imports-es6-autofix/sort-imports-es6
import 'regenerator-runtime/runtime';
import 'styles/application.scss';

import { RegRedesign } from 'reg_redesign/RegRedesign';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactOnRails from 'react-on-rails';

ReactOnRails.register({ RegRedesign });

window.addEventListener('app:forms:ready', () => {
  const regRedesignRoot = document.getElementById('reg-redesign-react-root');
  if (regRedesignRoot) {
    ReactDOM.render(<RegRedesign />, regRedesignRoot);
  }
});
